import { Flex, Text } from '@mantine/core';
import { IconLock, IconSparkles } from '@tabler/icons-react';
import { useCanChooseDefaultTemplate } from 'src/data-capture/hooks/templates/useCanChooseDefaultTemplate';

export function DefaultTemplateMenuFooter() {
  const canChooseDefault = useCanChooseDefaultTemplate();
  const Icon = canChooseDefault ? IconSparkles : IconLock;

  return (
    <Flex gap="xxs" align="flex-start" px="sm" py="xs">
      <Icon
        size={14}
        color={canChooseDefault ? 'var(--mantine-color-brand-6)' : 'var(--mantine-color-gray-6)'}
        style={{ flexShrink: 0, marginTop: 2 }}
        aria-hidden
      />
      <Text size="xs" c="gray.7">
        {canChooseDefault
          ? 'The default is the template we use to write notes automatically after every recorded meeting.'
          : 'A system admin at your firm chooses the default. We use it to write notes automatically after every recorded meeting.'}
      </Text>
    </Flex>
  );
}
